import _ from 'lodash'

export default function findParentCompany(parentId, institutions) {
  const parent = _.find(institutions, ['id', parentId])

  return parent
}
